import { makeStyles } from '@material-ui/core/styles';

export const useActivitiesHeaderStyles = makeStyles(() => ({
  dropdownElement: {
    width: '100%',
    position: 'relative',
    '&:hover #dropdownContainer': {
      transformOrigin: 'center top',
      transform: 'scaleY(1)'
    }
  },
  dropdownContainer: {
    background: '#5d5a7ee0',
    color: 'white',
    listStyle: 'none',
    padding: 0,
    textAlign: 'center',
    position: 'absolute',
    width: '100%',
    transform: 'scaleY(0)',
    transformOrigin: 'center top',
    transition: 'transform ease 0.5s',
    zIndex: 10
  },
  dropdownItem: {
    padding: 25,
    cursor: 'pointer',
    '& a': {
      color: 'white',
      textDecoration: 'none'
    }
  }
}));
